import React from 'react'
import styled from 'styled-components'

import Avatar from '~/components/common/avatar'
import { FlexCentered } from '~/components/common/containers'
import { translate } from '~/core/translate'
import { getDuration } from '~/core/utils/dates'
import ParticipantName, { TextContainer } from './participant-name'

const AvatarWrapper = styled.div`
  display: inline-block;
  margin-right: 16px;
`

const Row = styled(FlexCentered)`
  box-sizing: border-box;
  flex-shrink: 0;
  height: 48px;
  justify-content: space-between;
  padding: 8px 0;
  width: 100%;
`

const HeaderRow = styled(Row)`
  align-items: flex-start;
  height: 33px;
  padding: 0;

  ${TextContainer} {
    color: ${({ theme }) => theme._neo.textColor02};
  }
`

export const LabelLeft = styled.div`
  margin-right: 16px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
`

export const LabelRight = styled.div`
  max-width: 96px;
  text-align: right;

  ${TextContainer} {
    color: ${({ theme }) => theme._neo.textColor02};
  }
`

const ParticipantsList = ({ jids, participantsList, tabbable }) => (
  <div role='table' aria-label={translate('participants_list')}>
    <HeaderRow role='row'>
      <LabelLeft role='columnheader'>
        <TextContainer>{translate('name')}</TextContainer>
      </LabelLeft>
      <LabelRight role='columnheader'>
        <TextContainer>{translate('speaker_time')}</TextContainer>
      </LabelRight>
    </HeaderRow>
    {participantsList.map(participant => {
      const { jids: participantJids } = participant

      const isSelf = Boolean(participantJids.find(pJid => jids.includes(pJid)))

      return (
        <Row key={participantJids[0]} role='row'>
          <LabelLeft role='cell'>
            <AvatarWrapper>
              <Avatar
                role='presentation'
                size='xsmall'
                name={participant.name}
                useDynamicColor
                aria-hidden='true'
              />
            </AvatarWrapper>
            <ParticipantName isSelf={isSelf} participant={participant} />
          </LabelLeft>
          <LabelRight role='cell'>
            <TextContainer>
              {getDuration(participant.speakerTime)}
            </TextContainer>
          </LabelRight>
        </Row>
      )
    })}
  </div>
)

export default ParticipantsList
